<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :disabled="disabledControls" :icon-color="$root.$colors.primary" :label="$lang.selected" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="selected" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.disabled" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="disabled" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="8" sm12 equal-height v-for="(switcher, index) in switchers" :key="index">
        <card full-height :overflow-off="false">
          <card-text>
            <switcher @input="log('input', 'switcher', $event)" v-model="selected" :bg-color="switcher.color" :disabled="disabled" :key="index" :label="switcher.color" :bg-color-lightness="switcher.colorLightness" />
          </card-text>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">v-model: {{ selected }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageSwitcher',
  mixins: [
    methods
  ],
  data () {
    return {
      selected: true,
      disabled: false,
      switchers: this.$colors.swatches,
      disabledControls: false
    }
  },
  watch: {
    disabled () {
      this.disabledControls = !!this.disabled
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/switcher.vue